/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Loggerator from './loggerator'
import Vue from 'vue'
import ActivityTable from './activity_table.vue'
import ActionCable from "actioncable"
import ChartView from "./chart_view.vue"

//import ChartByAgent from './chart_by_agent.vue'

import "../styles/activities"
import "../styles/authenticated"
import "../styles/globals"
import "../styles/new_ui"

if(!window.Cable) {
  window.Cable = ActionCable.createConsumer()
}

function ready() {
  Loggerator.init();
  if (document.getElementById("activity-table")) {
    new Vue(ActivityTable).$mount('#activity-table')
  }
  if (document.getElementById("charts-container")) {
    new Vue(ChartView).$mount("#charts-container")
  }
}

$(document).on("page:load", ready).ready(ready);



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js